// extracted by mini-css-extract-plugin
export default {"DifferenceContainer":"ScoreCards_DifferenceContainer__dGyU-","Header":"ScoreCards_Header__uAJ8q"};